export enum InfluencerRoute {
  Post = 'post',
}
